import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Avatar,
  Box,
  Card,
  CardHeader,
  Flex,
  Heading,
  Text,
  Image,
  AccordionPanel,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineFundProjectionScreen, AiOutlineHome } from "react-icons/ai";
import {
  BsListTask,
  BsFingerprint,
  BsChatDots,
  BsGraphUpArrow,
  BsColumnsGap,
} from "react-icons/bs";
import { SlCalender } from "react-icons/sl";
import { HiOutlineDocumentText } from "react-icons/hi";
import { FaCoins, FaFileExcel, FaIdeal } from "react-icons/fa";
import { IoIosArrowDropdown, IoIosArrowDropupCircle } from "react-icons/io";
import companylogo from "../assets/companylogo.png";
import { useEffect } from "react";
import { fetchAttendances, getUsers } from "../Redux/app/action";
import { GrUserManager } from "react-icons/gr";

const CompanySidebar = () => {
  const globalState = useSelector((store) => store.authentication.data.token);
  //console.log(globalState);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);
  const id = useSelector((store) => store.authentication.users.id);
  const users = useSelector((store) => store.AppReducer.users);
  const filteredUser = users?.filter((obj) => obj._id === id) || [];

  const isActive = (pathname) => {
    return location.pathname === pathname;
  };

  const isPMSActive =
    location.pathname.startsWith("/project") ||
    location.pathname.startsWith("/admintask");
  const defaultIndex = isPMSActive ? [0] : [];

  useEffect(() => {
    dispatch(fetchAttendances());
  }, [dispatch]);
  const attendances = useSelector((state) => state.AppReducer.attendances);
  const empglobalState = useSelector((store) => store.authentication.users.id);
  const filteredData =
    attendances?.filter((obj) => obj.employee_id === empglobalState) || [];

  const reversedAttendances = [...filteredData].reverse();
  const attendance = reversedAttendances.find(
    (attendance) => attendance.employee_id === id
  );
  const getStatusColor = (status) => {
    return status === "Available" ? "green" : "red";
  };
  const statusColor = attendance ? getStatusColor(attendance.status) : "gray";
  return (
    <Box p={{ base: "none", md: 5 }} w={{ base: "100%", md: "15%" }}>
      <Box display={{ base: "none", sm: "block" }}>
        <Link to="/admin">
          <Box w={150}>
            <Image
              src={companylogo}
              width={{ base: "50%", sm: "50%", md: "50%" }}
              height="auto"
              objectFit="cover"
            />
          </Box>
        </Link>
        <br />
        <Link to="#">
          <Card
            maxW="md"
            bgGradient="linear(to-r, teal.300,  teal.100)"
            _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
          >
            <CardHeader>
              <Flex spacing="4">
                <Flex flex="1" gap="4" alignItems="center" flexWrap="wrap">
                  {/* <Avatar
                    name={globalState.first_name}
                    src={`https://develop-project-360.onrender.com/${filteredUser[0].path}`}
                    backgroundColor={"teal"}
                  /> */}
                  <Box
                    style={{
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    <Avatar
                      name={globalState.company_name}
                      size="sm"
                      src={
                        filteredUser[0]
                          ? `https://develop-project-360.onrender.com/${globalState?.logo?.path}`
                          : `https://develop-project-360.onrender.com/${globalState?.logo?.path}`
                      }
                    />

                    <span
                      style={{
                        position: "absolute",
                        bottom: "-2px", // Adjust this value to position the status dot properly
                        right: "-2px", // Adjust this value to position the status dot properly
                        display: "inline-block",
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor: statusColor,
                      }}
                    />
                  </Box>

                  <Box>
                    <Heading size="sm">{globalState.company_name}</Heading>
                    <Text textTransform={"capitalize"}>{globalState.role}</Text>
                  </Box>
                </Flex>
              </Flex>
            </CardHeader>
          </Card>
        </Link>
        <br />
        <br />
        <Heading size="md" fontWeight={"bold"} textAlign={"start"}>
          General
        </Heading>
        <br />
        <Accordion allowToggle lineHeight={8}>
          <Link to="/company">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/company") ? "green" : "green",
                  }}
                  color={isActive("/company") ? "green" : "inherit"}
                >
                  <AiOutlineHome />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Dashboard
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          <AccordionItem>
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    _hover={{ fontWeight: "semibold", color: "green" }}
                    color={isActive("/crm") ? "green" : "inherit"}
                  >
                    <FaCoins />
                    <Box as="span" flex="1" textAlign="left" ml={3}>
                      CRM
                    </Box>
                    {isExpanded ? (
                      <IoIosArrowDropupCircle />
                    ) : (
                      <IoIosArrowDropdown />
                    )}
                  </AccordionButton>
                </h2>

                <AccordionPanel pb={4}>
                  <Link to="/companysheets">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/companysheets") ? "green" : "green",
                      }}
                      color={isActive("/companysheets") ? "green" : "inherit"}
                    >
                      <FaFileExcel />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Sheets
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/companyleads">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/companyleads") ? "green" : "green",
                      }}
                      color={isActive("/companyleads") ? "green" : "inherit"}
                    >
                      <BsGraphUpArrow />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Leads
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/companydeals">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/companydeals") ? "green" : "green",
                      }}
                      color={isActive("/companydeals") ? "green" : "inherit"}
                    >
                      <FaIdeal />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Deals
                      </Box>
                    </AccordionButton>
                  </Link>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>

          <AccordionItem>
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    _hover={{ fontWeight: "semibold", color: "green" }}
                    color={isActive("/companyproject") ? "green" : "inherit"}
                  >
                    <AiOutlineFundProjectionScreen />
                    <Box as="span" flex="1" textAlign="left" ml={3}>
                      PMS
                    </Box>
                    {isExpanded ? (
                      <IoIosArrowDropupCircle />
                    ) : (
                      <IoIosArrowDropdown />
                    )}
                  </AccordionButton>
                </h2>

                <AccordionPanel pb={4}>
                  <Link to="/companyproject">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/companyproject") ? "green" : "green",
                      }}
                      color={isActive("/companyproject") ? "green" : "inherit"}
                    >
                      <AiOutlineFundProjectionScreen />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Project
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/companytask">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/companytask") ? "green" : "green",
                      }}
                      color={isActive("/companytask") ? "green" : "inherit"}
                    >
                      <BsListTask />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Task
                      </Box>
                    </AccordionButton>
                  </Link>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
          <AccordionItem>
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    _hover={{ fontWeight: "semibold", color: "green" }}
                    color={isActive("/companyemployees") ? "green" : "inherit"}
                  >
                    <BsColumnsGap />
                    <Box as="span" flex="1" textAlign="left" ml={3}>
                      HRMS
                    </Box>
                    {isExpanded ? (
                      <IoIosArrowDropupCircle />
                    ) : (
                      <IoIosArrowDropdown />
                    )}
                  </AccordionButton>
                </h2>

                <AccordionPanel pb={4}>
                  <Link to="/companyemployees">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/companyemployees")
                          ? "green"
                          : "green",
                      }}
                      color={
                        isActive("/companyemployees") ? "green" : "inherit"
                      }
                    >
                      <GrUserManager />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Employees
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/companyattendence">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/companyattendence")
                          ? "green"
                          : "green",
                      }}
                      color={
                        isActive("/companyattendence") ? "green" : "inherit"
                      }
                    >
                      <BsFingerprint />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Attendence
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/companygenerateletters">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/companygenerateletters")
                          ? "green"
                          : "green",
                      }}
                      color={
                        isActive("/companygenerateletters")
                          ? "green"
                          : "inherit"
                      }
                    >
                      <HiOutlineDocumentText />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Generate Letters
                      </Box>
                    </AccordionButton>
                  </Link>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>

          <Link to="/companychat">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/companychat") ? "green" : "green",
                  }}
                  color={isActive("/companychat") ? "green" : "inherit"}
                >
                  <BsChatDots />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Chats
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>

          <Link to="/companycalender">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/companycalender") ? "green" : "green",
                  }}
                  color={isActive("/companycalender") ? "green" : "inherit"}
                >
                  <SlCalender />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Calender
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
        </Accordion>
      </Box>
    </Box>
  );
};

export default CompanySidebar;
